module.exports = __webpack_public_path__ + "static/media/bowler-icon.f139a315.svg";